<div class="flex gap-3 text-xl">
  <vw-emoji-smile-icon class="size-7" [ngClass]="{
  'text-primary': selectedEmoji === 'smile',
  'text-gray-400': selectedEmoji !== 'smile'
   }" (click)="onSelectEmoji('smile')">
  </vw-emoji-smile-icon>
  <vw-emoji-meh-icon class="size-7" [ngClass]="{
  'text-primary': selectedEmoji === 'meh',
   'text-gray-400': selectedEmoji !== 'meh'
   }" (click)="onSelectEmoji('meh')">
  </vw-emoji-meh-icon>
  <vw-emoji-bad-icon class="size-7" [ngClass]="{
  'text-primary': selectedEmoji === 'bad',
   'text-gray-400': selectedEmoji !== 'bad'
   }" (click)="onSelectEmoji('bad')">
  </vw-emoji-bad-icon>
</div>